// extracted by mini-css-extract-plugin
export default {"checkbox":"InputCheckbox_checkbox__2I5iO","checkbox--line":"InputCheckbox_checkbox--line__30PZI","checkbox--list":"InputCheckbox_checkbox--list__7iIa4"};